import $ from 'jquery'
import Swal from 'sweetalert2'

export default {
  init() {

    $( '.my-favorite-permalink:not(.is-login)' ).on('click', function (event) {

      event.preventDefault();

      $('#login-modal').modal('show');

    })

    $( document ).on('click', '.add-to-wishlist', function(event) {

      event.preventDefault();

      var t = $(this);
      var action = null;

      t.addClass('is-loading');

      if ( ! t.hasClass('is-login') ) {

        $('html').addClass('show-sidebar show-sidebar-login')

        return false;

      }

      if ( t.hasClass('is-pressed') ) {
        action = 'remove_from_wishlist';
      }else{
        action = 'add_to_wishlist';
      }

      $.ajax({
        type: 'POST',
        // dataType: 'json',
        url: WISHLIST.ajaxurl,
        data: 'product_id=' + t.data('product_id') +'&security='+ WISHLIST.nonce +'&action=' + action,
        success : function( data ){

          t.toggleClass('is-pressed');
          t.removeClass('is-loading');

          if ( t.hasClass('is-page-wishlist') ) {
            t.closest('.product-item, .col-post').fadeOut(400, function() {
              $(this).remove();
            });
          }

          const Toast = Swal.mixin({
            toast: true,
            position: 'bottom-start',
            showConfirmButton: false,
            timer: 1500,
            timerProgressBar: true,
            onOpen: (toast) => {
              toast.addEventListener('mouseenter', Swal.stopTimer)
              toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
          })
          
          Toast.fire({
            icon: 'success',
            title: data
          })
        },
        complete: function(data){},
        error : function( err ){
        }

      });

    });

  },

  finalize() {
  },
};